import { FC } from 'react';

import _ from '../../../locale';
import SelectedCheckIcon from '../../SelectedCheckIcon';
import TruncatedTextWithTooltip from '../../TruncatedTextWithTooltip';
import { OptionList, SelectedRow, SelectedState, optionNameWrapperStyles } from './styles';

interface Props {
    label: string;
}

const SelectedOption: FC<Props> = ({ label }) => (
    <OptionList>
        <SelectedRow>
            <TruncatedTextWithTooltip text={label} wrapperStyles={optionNameWrapperStyles} />
            <SelectedState>
                {_('dex_chat_data_collection_selected')}
                <SelectedCheckIcon alt="" />
            </SelectedState>
        </SelectedRow>
    </OptionList>
);

export default SelectedOption;
